import KC_Text from "../../../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Text_Sizes,
  KC_Weights
} from "../../../../../designsystem/ds_commons";
import { tt } from "../../../../../utils/i18n/i18n";
import KC_UIText from "../../../../../designsystem/typography/KC_UIText/KC_UIText";
import PercentageControl from "../../../../../components/common/PercentageControl/PercentageControl";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../../designsystem/KC_Button/KC_Button";
import React, { type CSSProperties, useMemo } from "react";
import { computeTotalWinPc } from "../GiftSelector04Onboarding";
import { type Config, StockStrategy } from "kadow-jetpack-model";

interface Props {
  values: Config;
  className?: string;
  style?: CSSProperties;
}

export default function GiftSelectorFooter(props: Props) {
  // Real prizes that are not template
  const prizes = useMemo(() => {
    return props.values.prizes.filter((prize) => !prize.isTemplate);
  }, [props.values.prizes]);

  const winPc = useMemo(() => {
    return Math.ceil(
      computeTotalWinPc(
        prizes,
        props.values.stockStrategy || StockStrategy.None
      )
    );
  }, [props.values]);

  const percentageControlText = useMemo(() => {
    if (!winPc) {
      return (
        <KC_UIText
          weight={KC_Weights.reg}
          text={tt("gift_selector_specify_chance")}
        />
      );
    }

    if (winPc > 100) {
      return (
        <KC_UIText
          weight={KC_Weights.reg}
          text={tt("gift_selector_chance_exceed")}
        />
      );
    }

    return (
      <>
        {tt("jp_win_change_desc_00")}
        <span className="text-blue">{winPc}%</span>{" "}
        {tt("jp_win_change_desc_01")}
        <span className="text-blue">{Math.floor(100 - winPc)}%</span>
        {tt("jp_win_change_desc_02")}
      </>
    );
  }, [winPc]);

  if (!prizes.length) {
    return null;
  }

  return (
    <div
      className={`${props.className} footer-gift-selector p-4`}
      style={props.style}
    >
      <div className="w-100 d-flex flex-column gap-sm">
        <div className="d-flex justify-content-between flex-column">
          <KC_Text
            size={KC_Text_Sizes.lg}
            weight={KC_Weights.bold}
            text={tt("jp_win_change_text")}
          />
          <KC_UIText
            weight={KC_Weights.reg}
            text={percentageControlText}
            className={"display-lg"}
          />
        </div>
        {winPc >= 0 && winPc <= 100 && (
          <PercentageControl
            items={prizes}
            distributionType={props.values.stockStrategy || StockStrategy.None}
            lostPc={
              100 -
              computeTotalWinPc(
                prizes,
                props.values.stockStrategy ?? StockStrategy.None
              )
            }
          />
        )}
      </div>
      <div className="gift-selector-footer-btn">
        <KC_Button
          id="submit-btn"
          className="submit-btn d-flex"
          type={KC_ButtonType.Submit}
          text={tt("jp_validate_gift_text")}
          size={KC_ButtonSize.Giant}
        />
      </div>
    </div>
  );
}
